import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import AiIcon from "../../assets/icons/AiIcon";

const LoadingAiCard: React.FC<{ message: string }> = ({ message }) => {
  return (
    <Box>
      <Card>
        <CardContent
          sx={{
            padding: "16px !important",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              animation: "blink 1.5s infinite",
              "@keyframes blink": {
                "0%": { opacity: 0.3 },
                "50%": { opacity: 1 },
                "100%": { opacity: 0.3 },
              },
            }}
          >
            <AiIcon />
          </Box>
          <Typography variant="body1" sx={{ textAlign: "center", fontStyle: "italic" }}>
            {message}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoadingAiCard;
